<template>
  <section class="content-current">
    <div class="row">
      <div class="col-md-11"></div>
      <div class="col-md-1">
        <div title="بازگشت به داشبورد" class="close" @click="closeDetail"></div>
      </div>
    </div>
    <div class="">
      <table class="table tablesorter  add_bottom_30">
        <thead class="thead-light">
          <tr>
            <th>شماره رزرو</th>
            <th>تاریخ ثبت</th>
            <th>نام مهمان</th>
            <th>نام هتل</th>
            <th>ورود</th>
            <th>خروج</th>
            <th>وضعیت پرداخت</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>Louvre Museum ticket</td>
            <td>test</td>
            <td>امیر محمد فیروزی</td>
            <td>هتل داریوش کیش</td>
            <td>1399/07/03</td>
            <td>1399/07/03</td>

            <td>پرداخت نشده</td>
          </tr>
          <tr>
            <td>
              <span class="item_cart">Louvre Museum tickets</span>
            </td>
            <td>
              <div class="numbers-row">test</div>
            </td>
            <td>تست asdasd</td>
            <td>هتل داریوش کیش</td>
            <td>1399/07/03</td>
            <td>1399/07/03</td>
            <td>پرداخت نشده</td>
          </tr>
          <tr>
            <td>
              <span class="item_cart">Louvre Museum tickets</span>
            </td>
            <td>
              <div class="numbers-row">test</div>
            </td>
            <td>تست asdasd</td>
            <td>هتل داریوش کیش</td>
            <td>1399/07/03</td>
            <td>1399/07/03</td>
            <td>پرداخت نشده</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
export default {
  name: "",
  data() {
    return {};
  },
  methods: {
    closeDetail() {
      this.$emit("showDetail", true);
    },
  },
};
</script>


